module.exports = __webpack_public_path__ + "static/media/purple_back.44961e95.png";